import React from "react";
import socialImage from "../img/Соц-проектирование.png";
import educationImage from "../img/Продюсирование.png";
import productionImage from "../img/Управление-проектами.png";
import { DirectionCard } from "../utils/DirectionCard";

export const Production = () => {
  const Production = [
    {
      title: "Социокультурное проектирование",
      description: "Исследуем взаимодействие общества, культуры, психологии. Наша команда разрабатывает проекты, направленные на улучшение социального климата, поддержку культурных инициатив, формирование комфортной среды для обмена идеями. Мы проводим исследования, анализируем социокультурные потребности, создаем программы, которые направлены на преодоление современных вызовов.",
      image: socialImage,
    },
    {
      title: "Креативное продюсирование",
      description: "Мы помогаем авторам, творческим коллективам преобразовать свои видения в успешные проекты. Наша лаборатория предлагает поддержку на всех этапах создания: от концепции и сценария до пост-продакшн. Мы ищем нестандартные решения, развиваем новые форматы работы, чтобы каждый проект стал уникальным и запоминающимся.",
      image: educationImage,
    },
    {
      title: "Разработка, внедрение, сопровождение проектов, подходов, программ различной направленности",
      description: "Мы не только разрабатываем идеи, но и активно занимаемся внедрением, сопровождением проектов. Наша задача – поддерживать начинания на всех этапах: от планирования до реализации и оценки эффективности.",
      image: productionImage,
    },
  ]
  return (
    <div id="testimonials">
      <div className="container">
        <div className="section-title text-center">
          <h2>Продакшн</h2>
          <div className="education-intro">
            <p>
            <strong>Экспериментально-творческая лаборатория.</strong> Программы, где через <em>искусство</em> и <em>интересный</em> опыт мы помогаем раскрыть скрытые таланты и идеи.
            <br/><br/>
            Мы стремимся создать пространство для экспериментов, сотрудничества, где идеи обретают форму, а ведение проектов становится источником вдохновения. Наша экспериментально-творческая лаборатория работает по направлениям
            </p>
          </div>
        </div>
        <div className="card-grid">
          {Production.map((item, index )=>(
            <DirectionCard
            key={index}
            title={item.title}
            description={item.description}
            image={item.image}
            showButton={true} 
            />
          ))}
        </div>
      </div>
      <div className="project-text-block">
          <p>Присоединяйтесь к нам на пути к новым высотам в сфере психологии, творчества! Делитесь своими идеями, вместе мы создадим что-то поистине уникальное.</p>
        </div>
    </div>
  );
};
